import { curStateAccount } from '@/Redux/selector';
import { hasAuthCookie } from '@/utils/auth';
import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from 'react-redux';
const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
	const [isOpen, setIsOpen] = useState(false);
	const [onSuccessCallback, setOnSuccessCallback] = useState(null);
	const account = useSelector(curStateAccount);

	const isAuthed =
		hasAuthCookie() || Boolean(account?.userInfo) || Boolean(account?.token);

	// force: bỏ qua check isAuthed (vd: API 401 nhưng cookie token vẫn còn)
	const openLogin = useCallback((onSuccess, { force = false } = {}) => {
		if (isAuthed && !force) {
			onSuccess?.();
			return;
		}

		setOnSuccessCallback(() => onSuccess || null);
		setIsOpen(true);
	}, [isAuthed]);

	const closeLogin = useCallback(() => {
		setIsOpen(false);
		setOnSuccessCallback(null);
	}, []);

	const handleLoginSuccess = useCallback((data) => {
		onSuccessCallback?.(data);
		closeLogin();
	}, [onSuccessCallback, closeLogin]);

	return (
		<LoginModalContext.Provider value={{ isOpen, openLogin, closeLogin, handleLoginSuccess }}>
			{children}
		</LoginModalContext.Provider>
	);
}

export function useLoginModal() {
	const ctx = useContext(LoginModalContext);
	if (!ctx) throw new Error("useLoginModal phải dùng trong LoginModalProvider");
	return ctx;
}